const EVENTS = {
  IMPRESSION: 'impression',
  CLICK: 'click',
  CANCEL: 'cancel',
  SUBMIT: 'submit'
};

export default EVENTS;
